import styled from "styled-components";
import { maxSize, px2vw, textLineClamp } from "../../Utils/common";
import { STYLE_TYPE, themeColor } from "../../Utils/magicStrings";

export const ExploreWrapper = styled('div')`
`;

export const ExploreTitleWrapper = styled('div')`
    position: relative;
    ${props => maxSize(73, props.styleType, 'margin-top', 32)};
    ${props => maxSize(146, props.styleType, 'margin-left', 16)};
    ${props => maxSize(25, props.styleType, 'margin-bottom', 16)};
`;

export const ExploreMainTitle = styled('div')`
    ${props => maxSize(56, props.styleType, 'font-size', 30)};
    ${props => maxSize(56, props.styleType, 'line-height', 30)};
    letter-spacing: 0.08em;
`;

export const ExploreSubTitle = styled('div')`
    ${props => maxSize(24, props.styleType, 'font-size', 18)};
    ${props => maxSize(38, props.styleType, 'line-height', 23)};
    ${props => maxSize(10, props.styleType, 'margin-top', 6)};
    letter-spacing: 0.02em;
`;

export const ExploreLine = styled('div')`
    ${props => maxSize(1147,  props.styleType, 'width', 343)};
    ${props => maxSize(146, props.styleType, 'margin-left', 16)};
    border-top: 1px ${themeColor} solid;
`;

export const ExploreSubLine = styled('div')`
    ${props => maxSize(230,  props.styleType, 'width', 81)};
    ${props => maxSize(146, props.styleType, 'margin-left', 16)};
    border-top: ${props => props.styleType === STYLE_TYPE.MOBILE ? '3px' : '9px'} ${themeColor} solid;
`;

export const ExploreFilterNumber = styled('div')`
    position: absolute;
    display: flex;
    align-items: center;
    ${props => maxSize(27,  props.styleType, 'top', 15)};
    ${props => maxSize(168,  props.styleType, 'right', 24)};
    & #text {
        ${props => maxSize(14, props.styleType, 'font-size', 12)};
    }
    & #number {
        background-color: ${themeColor};
        border-radius: 50%;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        ${props => maxSize(57, props.styleType, 'width', 41)};
        ${props => maxSize(57, props.styleType, 'height', 41)};
        ${props => maxSize(32, props.styleType, 'font-size', 24)};
        ${props => maxSize(12, props.styleType, 'margin-left', 8)};
    }
`;

export const FilterSettingBoardWrapper = styled('div')`
    display: flex;
    align-items: center;
    ${props => maxSize(30, props.styleType, 'margin-top', 19)};
    ${props => maxSize(22, props.styleType, 'margin-bottom', 13)};
    position: relative;
`;

export const KeywordChoiceWrapper = styled('div')`  
    display: flex;
    align-items: center;
    ${props => maxSize(14, props.styleType, 'font-size', 12)};
    ${props => maxSize(153, props.styleType, 'margin-left', 16)};
    ${props => maxSize(34, props.styleType, 'height', 12)};
    & span {
        border-right: 1px solid black;
        ${props => maxSize(2.88, props.styleType, 'margin-top', 0.1)};
        ${props => maxSize(8, props.styleType, 'margin-left', 8)};
        ${props => maxSize(16, props.styleType, 'padding-right', 8)};
    }
`;
//${props => props.styleType !== STYLE_TYPE.MOBILE && }


export const CrossWrapper = styled('div')`
    ${props => maxSize(props.PCSize*1.4142, props.styleType, 'width', props.mobileSize * 1.4142)};
    ${props => maxSize(props.PCSize*1.4142, props.styleType, 'height', props.mobileSize * 1.4142)};
    ${props => props.showMargin && maxSize(7, props.styleType, 'margin-right', 7)};
    transform: rotate(45deg);
    position: relative;
    display: inline-block;
    & #left {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        width: 100%;
        border-top: 1px solid ${props => props.color};
    }
    & #right {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        height: 100%;
        border-left: 1px solid ${props => props.color};
        
    }
`;

export const FilterIconWrapper = styled('div')`
    position: relative;
    display: inline-block;
    ${props => maxSize(31, props.styleType, 'width', 23)};
    ${props => maxSize(16, props.styleType, 'height', 12)};
    & #upperLine {
        position: absolute;
        width: 100%;
        ${props => maxSize(2, props.styleType, 'height', 1.48)};
        ${props => maxSize(2, props.styleType, 'bottom', 1.48)};
        background-color: black;
    }
    & #lowerLine {
        position: absolute;
        width: 100%;
        ${props => maxSize(2, props.styleType, 'height', 1.48)};
        ${props => maxSize(2, props.styleType, 'top', 1.48)};
        background-color: black;
    }
    & #upperPoint {
        position: absolute;
        background-color: black;
        border-radius: 50%;
        ${props => maxSize(6, props.styleType, 'width', 4.45)};
        ${props => maxSize(6, props.styleType, 'height', 4.45)};
        ${props => maxSize(0, props.styleType, 'top', 0)};
        ${props => maxSize(8, props.styleType, 'left', 5.94)};
    }
    & #lowerPoint {
        position: absolute;
        background-color: black;
        border-radius: 50%;
        ${props => maxSize(6, props.styleType, 'width', 4.45)};
        ${props => maxSize(6, props.styleType, 'height', 4.45)};
        ${props => maxSize(0, props.styleType, 'bottom', 0)};
        ${props => maxSize(8, props.styleType, 'right', 5.94)};
    }
`;

export const KeywordsWrapper = styled('div')`
    display: flex;
    ${props => maxSize(16, props.styleType, 'margin-left', 8)};
    ${props => maxSize(0, props.styleType, 'margin-right', 8)};
    ${props => maxSize(14, props.styleType, 'font-size', 11)};
    text-decoration-line: underline;
    color: #0057FF;
    cursor: pointer;
`;

    // ${props => {
    //     if(props.styleType === STYLE_TYPE.MOBILE) {
    //         return `
    //             position: absolute;
    //             left: ${px2vw(8, 375)};
    //             top: ${px2vw(33, 375)};
    //         `
    //     } else {
    //         return `

    //         `
    //     }
    // }}

export const Keywords = styled('div')`
    display: flex;
    align-items: center;
    color: white;
    background-color: ${themeColor};
    border-radius: 15px;
    position: relative;
    ${props => maxSize(30, props.styleType, 'height', 27)};
    ${props => maxSize(8, props.styleType, 'padding-left', 8)};
    ${props => maxSize(8, props.styleType, 'padding-right', 8)};
    ${props => maxSize(14, props.styleType, 'font-size', 10)};
    ${props => maxSize(8, props.styleType, 'margin-left', 8)};
    & span {
        display: inline-block;
        ${props => maxSize(4, props.styleType, 'margin-right', 2)};
    }
`;

export const Clear = styled('div')`
    border-left: 1px solid black; 
    ${props => maxSize(16, props.styleType, 'margin-left', 0.1)};
    ${props => maxSize(16, props.styleType, 'padding-left', 8)};
    ${props => maxSize(14, props.styleType, 'font-size', 12)};
`;

export const TypeFilterWrapper = styled('div')`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    ${props => maxSize(14, props.styleType, 'font-size', 12)};
    ${props => maxSize(142, props.styleType, 'margin-right', 24)};
    & #has {
        color: ${themeColor};
    }
    & span {
        display: inline-block;
    }
`;

export const ArrowWrapper = styled('div')`
    ${props => maxSize(props.PCSize * 1.4142, props.styleType, 'width', props.mobileSize * 1.4142)};
    ${props => maxSize(props.PCSize * 1.4142, props.styleType, 'height', props.mobileSize * 1.4142)};
    ${props => {
        if(props.arrow === 'up') {
            return `
                ${maxSize(-4, props.styleType, 'margin-bottom', -4)};
                ${maxSize(8, props.styleType, 'margin-right', 8)};
                transform: rotate(135deg);
            `
        } else {
            return `
                ${maxSize(2, props.styleType, 'margin-bottom', 2)};
                ${maxSize(8, props.styleType, 'margin-right', 8)};
                transform: rotate(-45deg);
            `
        }
    }};
    border-left: 1px solid black;
    border-bottom: 1px solid black;
    display: inline-block;
`;

export const BoardItemWrapper = styled('div')`
    ${props => maxSize(14, props.styleType, 'font-size', 10)};
    ${props => {
        if(props.type === 'keyword') {
            return `
                ${maxSize(8, props.styleType, 'padding-right', 8)};
                ${maxSize(8, props.styleType, 'padding-left', 8)};
                ${maxSize(33, props.styleType, 'line-height', 27)};
                ${maxSize(props.haschecked ? 30 : 32, props.styleType, 'height', props.haschecked ? 25 : 27)};
                ${maxSize(props.haschecked ? 70 : 72, props.styleType, 'width', props.haschecked ? 46 : 48)};
                ${maxSize(92 , props.styleType, 'margin-right', 60)};
                ${maxSize(24 , props.styleType, 'margin-top', 20)};
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                ${props.styleType === STYLE_TYPE.MOBILE ? 'text-align: center' : '' };
                & #sharp {
                    display: ${props.styleType === STYLE_TYPE.MOBILE ? 'none' : 'inline-block'};
                    ${maxSize(4, props.styleType, 'margin-right', 4)}
                }
                ${props.haschecked && 'border: 1px solid #B69A67;border-radius: 15px;'};
            `
        } else {
            const uncheckedCSS = `
                border: 1px solid #9A9A9A;
                border-radius: 2px;
                & img {
                    visibility: hidden;
                }
            `;
            const checkedCSS = `
                background: #B69A67;
                border: 1px solid #B69A67;
                border-radius: 2px;
                & img {
                    ${maxSize(3 , props.styleType, 'margin-top', 0)};
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
            `;
            return `
                flex: ${props.styleType === STYLE_TYPE.MOBILE ? '0 0 50%'  : '0 0 20%'};
                display: flex;
                align-items: center;
                ${maxSize(24 , props.styleType, 'margin-top', 24)};
                & #checkedPC {
                    display: ${props.styleType === STYLE_TYPE.MOBILE ? 'none'  : 'inline-block'};
                    ${maxSize(15, props.styleType, 'height', 4)};
                    ${maxSize(15, props.styleType, 'width', 4)};
                    ${maxSize(8, props.styleType, 'margin-right', 4)};
                    ${props.haschecked ? checkedCSS : uncheckedCSS }
                }
                & #text {
                    flex: 1 0 auto;
                }
                & #checkedMobile {
                    display: ${props.styleType === STYLE_TYPE.MOBILE ? 'inline-block'  : 'none'};
                    ${maxSize(15, props.styleType, 'height', 15)};
                    ${maxSize(15, props.styleType, 'width', 15)};
                    ${maxSize(8, props.styleType, 'margin-left', 8)};
                    ${maxSize(0, props.styleType, 'margin-right', 16)};
                    ${props.haschecked ? checkedCSS : uncheckedCSS }
                }
            `
        }
    }}
`;




export const BoardWrapper = styled('div')`
    margin: auto;
    background-color: #F3EBE2;
    box-sizing: border-box;
    & :nth-child(${props => props.styleType === STYLE_TYPE.MOBILE ? '2n+2' : '5n+5'}) {
        margin-right: 0;
    }
    ${props => {
        // if(props.styleType === STYLE_TYPE.MOBILE && props.type === 'type') {
        //     return `
        //         ${maxSize(1144, props.styleType, 'width', 375)};
        //         ${maxSize(24, props.styleType, 'margin-top', -30)};
        //         ${maxSize(8, props.styleType, 'padding-top', 0)};
        //         ${maxSize(40, props.styleType, 'padding-bottom', 0)};
        //         ${maxSize(40, props.styleType, 'padding-left', 129)};
        //         ${maxSize(265, props.styleType, 'padding-right', 20)};
        //     `
        // } else {
            return `
                ${maxSize(1144, props.styleType, 'width', 343)};
                ${maxSize(24, props.styleType, 'margin-top', 13)};
                ${maxSize(8, props.styleType, 'padding-top', 0.1)};
                ${maxSize(0, props.styleType, 'padding-left', 16)};
                ${maxSize(40, props.styleType, 'padding-bottom', 0.1)};
            `
        //}
    }}

`;

export const HotelCardWrapper = styled('div')`
    margin: auto;
    position: relative;
    background-color: ${themeColor};
    ${props => maxSize(16, props.styleType, 'margin-top', 16)};
    ${props => maxSize(1144, props.styleType, 'width', 343)};
    ${props => maxSize(343, props.styleType, 'height', 467)};
`;

export const HotelImg = styled('div')`
    ${props => maxSize(650, props.styleType, 'width', 343)};
    ${props => maxSize(343, props.styleType, 'height', 217)};
    & img {
        width: 100%;
    }
`;
export const HotelInfoWrapper = styled('div')`

`;
export const HotelTitle = styled('div')`
    position: absolute;
    color: #FFFFFF;
    font-weight: 600;
    letter-spacing: 0.02em;
    ${props => maxSize(73, props.styleType, 'top', 241)};
    ${props => maxSize(680, props.styleType, 'left', 16)};
    ${props => maxSize(430, props.styleType, 'max-width', 311)};
    ${props => maxSize(18, props.styleType, 'font-size', 14)};
    ${props => maxSize(32, props.styleType, 'line-height', 24)};
    ${props => {
            if(props.styleType === STYLE_TYPE.MOBILE) {
                return `
                    ${textLineClamp(2)};
                `
            } else {
                return `
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                `
            }
        }
    }
`;
export const HotelDetail = styled('div')`
    position: absolute;
    color: #FFFFFF;
    letter-spacing: 0.02em;
    ${props => textLineClamp(props.styleType === STYLE_TYPE.MOBILE ? 4 : 3)};
    ${props => maxSize(109, props.styleType, 'top', 291)};
    ${props => maxSize(680, props.styleType, 'left', 16)};
    ${props => maxSize(430, props.styleType, 'max-width', 311)};
    ${props => maxSize(12, props.styleType, 'font-size', 10)};
    ${props => maxSize(24, props.styleType, 'line-height', 20)};
`;
export const HotelTagsWrapper = styled('div')`
    position: absolute;
    color: #FFFFFF;
    display: flex;
    ${props => maxSize(191, props.styleType, 'top', 377)};
    ${props => maxSize(680, props.styleType, 'left', 17)};
    ${props => maxSize(430, props.styleType, 'max-width', 311)};
`;

export const HotelTag = styled('div')`
    color: #FFFFFF;
    ${props => maxSize(16, props.styleType, 'margin-right', 8)};
    ${props => maxSize(12, props.styleType, 'font-size', 10)};
    ${props => maxSize(17, props.styleType, 'line-height', 17)};
`;

export const HotelGoTo = styled('div')`
    border: 1px solid #FFFFFF;
    border-radius: 21px;
    position: absolute;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    ${props => maxSize(257, props.styleType, 'top', 405)};
    ${props => maxSize(680, props.styleType, 'left', 17)};
    ${props => maxSize(106, props.styleType, 'width', 300)};
    ${props => maxSize(32, props.styleType, 'height', 36)};
    ${props => maxSize(14, props.styleType, 'font-size', 14)};
    & img {
        ${props => maxSize(5, props.styleType, 'margin-left', 5)};
        ${props => maxSize(10, props.styleType, 'width', 10)};
        ${props => maxSize(9, props.styleType, 'height', 9)};

    }
`;

export const ShowMoreWrapper = styled('div')`
    text-align: center;
    color: #BCB4A7;
    ${props => maxSize(40, props.styleType, 'margin-top', 16)};
    ${props => maxSize(14, props.styleType, 'font-size', 12)};
    & img {
        display: block;
        margin: auto;
        ${props => maxSize(4, props.styleType, 'margin-top', 4)};
        ${props => maxSize(10, props.styleType, 'height', 10)};
        ${props => maxSize(27, props.styleType, 'width', 27)};
    }
`;


export const KeyWordLineWrapper = styled('div')`
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                ${maxSize(16, props.styleType, 'margin-top', 12)};
            `;
        } else {
            return `
                display: flex;
                align-items: center;
                ${maxSize(46, props.styleType, 'height', 10)};
                ${maxSize(16, props.styleType, 'margin-top', 10)};
                ${maxSize(14, props.styleType, 'font-size', 12)};
            `
        }
    }}
`;

export const TagLineWrapper = styled('div')`
    ${props => maxSize(25, props.styleType, 'margin-left', 0.1)};
    ${props => maxSize(16, props.styleType, 'margin-top', 12)};
    ${props => maxSize(14, props.styleType, 'font-size', 12)};
`;


export const KeySelectItemWrapper = styled('div')`
    & :last-child {
        border-right: none;
    }
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
            border: 1px solid #8F7951;
            border-radius: 4px;
            display: inline-block;
            ${maxSize(33, props.styleType, 'height', 33)};
            ${maxSize(33, props.styleType, 'margin-top', 8)};
            font-size: 0;
            white-space: nowrap;
            `
        } else {
            return `
            display: flex;
            height: 100%;
            align-items: center;
            border: 1px solid #8F7951;
            box-sizing: border-box;
            border-radius: 4px;
            
            `
        }
    }}
`;

export const TagSelectItemWrapper = styled('div')`
    & :last-child {
        border-right: none;
    }
    border: 1px solid #8F7951;
    border-radius: 4px;
    display: inline-block;
    ${props => maxSize(46, props.styleType, 'height', 33)};
    ${props => maxSize(16, props.styleType, 'margin-top', 8)};
    font-size: 0;
    white-space: nowrap;
        
`;


export const KeyWordKey = styled('div')`
${props => {
    if(props.styleType === STYLE_TYPE.MOBILE) {
        return `

        `
    } else {
        return `
        flex: none;
        text-align: right;
        ${maxSize(148, props.styleType, 'width', 12)};
        ${ maxSize(20, props.styleType, 'padding-right', 12)};
        `
    }
}}

`;

export const KeywordSelectItem = styled('div')`
height: 100%;
display: inline-flex;
align-items: center;
cursor: pointer;
${props => maxSize(16, props.styleType, 'padding-left', 8)};
${props => maxSize(16, props.styleType, 'padding-right', 8)};
${props => maxSize(14, props.styleType, 'font-size', 10)};


${props => {
    if(props.isChosen) {
        return `
            background: #B69A67;
            color: white;
        `
    }
}}
border-right: 1px solid #8F7951;
`;

export const KeywordButtonWrapper = styled('div')`
    display: flex;
    ${props => maxSize(168, props.styleType, 'margin-left', 0.1)};
    ${props => maxSize(0.1, props.styleType, 'margin-bottom', 20)};

    ${props => maxSize(24, props.styleType, 'margin-top', 12)}

`;

export const TagButtonWrapper = styled('div')`
    display: flex;
    ${props => maxSize(25, props.styleType, 'margin-left', 0.1)};
    ${props => maxSize(0.1, props.styleType, 'margin-bottom', 20)};

    ${props => maxSize(24, props.styleType, 'margin-top', 12)}

`;

export const KeywordButton = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
    ${props => maxSize(46, props.styleType, 'height', 33)};
    ${props => maxSize(77, props.styleType, 'width', 65)};
    ${props => {
        if(props.isSave) {
            return `
            color: white;
            background: #B69A67;
            ${maxSize(12, props.styleType, 'margin-right', 8)};
            
            `
        } else {
            return `
            background: #DFDFDF;

            `
        }
    }}
`;

export const EmptyModal = styled('div')`
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                position: absolute;
                bottom: 0;
                box-shadow: 0px -3px 24px rgba(0, 0, 0, 0.12);
            `;
        } else {
            return `
            position: absolute;
            top: 50%;
            left: 50%;
            border-radius: 12px;
            transform: translate(-50%, -50%);`
        }
    }}
   
    background: #F8F5F1;
    ${props => maxSize(306, props.styleType, 'height', 189)};
    ${props => maxSize(500, props.styleType, 'width', 375)};
    display: flex;
    flex-direction: column;
    align-items: center;
    & .title {
        ${props => maxSize(47, props.styleType, 'margin-top', 24)};
        ${props => maxSize(24, props.styleType, 'font-size', 14)};
    }
    & .content {
        ${props => maxSize(16, props.styleType, 'font-size', 12)};
        ${props => maxSize(224, props.styleType, 'width', 168)};
        ${props => maxSize(30, props.styleType, 'line-height', 24)};
        ${props => maxSize(24, props.styleType, 'margin-top', 24)};
        color: #AA9372;
        text-align: center;
    }
    & .button {
        ${props => maxSize(24, props.styleType, 'font-size', 16)};
        ${props => maxSize(70, props.styleType, 'height', 56)};
        ${props => maxSize(241, props.styleType, 'width', 375)};
        ${props => maxSize(32, props.styleType, 'margin-top', 32)};
        background: #D1BB8B;
        border-radius: ${props => props.styleType === STYLE_TYPE.MOBILE ? '0px' : '35px'};
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;